import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Subscription } from 'rxjs'
import { IContact } from 'src/app/schemas'
import { ApiService } from 'src/app/services'

@Component({
  selector: 'app-contact-detail',
  imports: [],
  templateUrl: './contact-detail.component.html',
  styleUrl: './contact-detail.component.scss',
})
export class ContactDetailComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute)
  private apiService = inject(ApiService)
  private destroyRef = inject(DestroyRef)

  contact = signal<IContact | null>(null)

  ngOnInit(): void {
    let svcSub: Subscription | undefined
    const routeSub = this.activatedRoute.paramMap.subscribe({
      next: (paramMap) => {
        const id = paramMap.get('contactId')
        if (!id) throw new Error('Invalid contact id')

        svcSub = this.apiService.getContact(+id).subscribe({
          next: (c) => this.contact.set(c),
        })
      },
    })

    this.destroyRef.onDestroy(() => {
      routeSub.unsubscribe()
      svcSub?.unsubscribe()
    })
  }
}
